var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromoMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#54979c"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.424,
    y: 376,
    style: {
      fill: "#000000"
    },
    width: 285.144,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.296,
    y: 400,
    style: {
      fill: "#000000"
    },
    width: 197.408,
    height: 8
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 144.24,
    r: 50.776
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f0013"
    },
    d: "M343.584,307.552c0,0,0,2.368,0-44.944s-51.64-48.176-51.64-48.176h-71.888 c0,0-51.64,0.576-51.64,48.176c0,47.312,0,44.944,0,44.944H343.584z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoMenu);
export default __webpack_public_path__ + "static/media/promo_menu.0b453ef07ef5649d2cc51b6404cd95bd.svg";
export { ForwardRef as ReactComponent };